import { render, staticRenderFns } from "./BasePrizeList.vue?vue&type=template&id=ccb783a6&scoped=true&"
import script from "./BasePrizeList.vue?vue&type=script&lang=js&"
export * from "./BasePrizeList.vue?vue&type=script&lang=js&"
import style0 from "./BasePrizeList.vue?vue&type=style&index=0&id=ccb783a6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ccb783a6",
  null
  
)

export default component.exports